import {css} from "@emotion/css";
import {ArtworkState, getLeverValue, indexAllLevers, Layout, LeverDefinition, Manifest} from "./layered_static_v1";
import React, {useMemo} from "react";
import { keyBy } from "lodash";

export function Controls(props: {
  master: any,
  manifest: Manifest,
  chainValues: ArtworkState,
  userValues: ArtworkState,
  onUserValuesChange: (userValues: ArtworkState) => void
}) {
  const {master, manifest} = props;
  console.log('IPFS Manifest', manifest);
  console.log('Chain Master Record', master);

  function handleLeverUpdate(tokenId: number, leverId: number, newValue: number) {
    let newValues = {
      ...props.userValues,
      [`${tokenId}/${leverId}`]: newValue
    }
    props.onUserValuesChange(newValues);
  }

  const leverData = useMemo(() => {
    if (!manifest) {
      return null;
    }
    return keyBy(indexAllLevers(manifest.layout), 'leverId');
  }, [manifest]);

  const fullState = useMemo(() => {
    return {...props.chainValues, ...props.userValues}
  }, [props.chainValues, props.userValues])

  return <div className={css`
    padding: 10px;
    overflow: auto;
  `}>
    <div>
      ID: <a
        href={`https://async.art/art/master/0xb6dae651468e9593e4581705a09c10a76ac1e0c8-${master?.tokenDetails.tokenId}`}>{master?.tokenDetails.tokenId}</a>
    </div>
    <div className={css`
      display: flex;
      flex-direction: column;
      align-items: flex-start;
    `}>
      <strong className={css`margin: 10px 0; background: #efefef; padding: 5px; display: block`}>
        Layers ({manifest?.layout.layers.length}):
      </strong>
      {
        manifest?.layout.layers.map((layer: any) => {
          return <div key={layer.id} className={css``}>
            {layer.id}
          </div>
        })
      }
    </div>

    <div className={css`
      display: flex;
      flex-direction: column;
      align-items: stretch;
    `}>
      <strong className={css`margin: 10px 0; background: #efefef; padding: 5px; display: block`}>Levers</strong>
      {
        master?.layers.map((layer: any) => {
          const layerTokenId = parseInt(layer.tokenDetails.tokenId);
          const masterTokenId = parseInt(master?.tokenDetails.tokenId);
          const relativeTokenId = layerTokenId - masterTokenId;  // AsyncArt system: if master token is 3, control tokens are 4, 5, 6, ...

          return <div key={layer.id} style={{marginBottom: '25px'}}>
            <strong className={css`margin-bottom: 10px; display: block;`}>ControlToken {relativeTokenId}: <br/></strong>
            {
              layer.levers.map((lever: any, idx: number) => {
                const leverId = `${relativeTokenId}/${idx}`;
                const leverInfo = leverData?.[leverId];
                const label = leverInfo ? leverInfo?.location.join('/') : `[${{leverId}}]`

                const currentValue = getLeverValue(fullState!, layer.tokenDetails.tokenId, idx);

                return <div style={{marginBottom: '10px'}}>
                  {label} - {leverInfo?.type}:<br/>

                  <Lever
                      lever={lever}
                      leverInfo={leverInfo}
                      value={currentValue}
                      onChange={newValue => {
                        handleLeverUpdate(layer.tokenDetails.tokenId, idx, newValue);
                      }}
                  />

                  <a
                    href={""}
                    style={{
                      display: 'block',
                      fontSize: '0.5em',
                      visibility: currentValue != lever.currentValue ? 'visible' : 'hidden'
                    }}
                    onClick={(e) => {
                      e.preventDefault();
                      handleLeverUpdate(layerTokenId, idx, lever.currentValue);
                    }}
                  >Reset to current chain state</a>
                </div>
              })
            }
          </div>
        })
      }
    </div>
  </div>
}

function Lever(props: {
  lever: any,
  leverInfo: LeverDefinition|undefined
  value: number,
  onChange: (newValue: number) => void
}) {
  const lever = props.lever;

  if (props?.leverInfo?.optionLabels) {
    return <div>
      <select onChange={e => {
        props.onChange(parseInt(e.currentTarget.value))
      }} style={{
        fontSize: '18px'
      }}>
        {props?.leverInfo?.optionLabels.map((option, idx) => {
          return <option value={idx}>{option}</option>
        })}
      </select>
    </div>
  }

  return <div>
    <div style={{color: 'silver', fontSize: '0.7em'}}>{props.value} ({lever.minValue} to {lever.maxValue})</div>
    <input type="range" step={1} value={props.value} min={lever.minValue} max={lever.maxValue} onChange={e => {
      props.onChange(parseInt(e.currentTarget.value))
    }}
    />
  </div>
}